import { useMemo, useEffect, useState } from "react";
import { AddUpdateParticipantModal, BackButton, BadgeComponent, Breadcrumbs, ButtonComponent, ConfirmationModalComponent, DropDownComponent, FiltersComponent, IconButtonComponent, LoaderComponent, PaginationComponent } from "../../components";
import { CrossSvg, PlusSvg, SearchSvg, VerticalDotsSvg } from "../../assets/svgs";
import { useDispatch, useSelector } from "react-redux";
import { providerInstitutionConstant, statusConstant, statusOptions } from "../../constants/user-constants";
import { getAllParticipants, getParticipantsLogoDetail, getParticipantsMessageInfo, postAddUpdateParticipant,getCountryList } from "../../redux/slices/participants-slice";
import { AuthPageContainer, AuthPageHead, ReactTableWrapper, ReactTableWrappers } from "../../styles/global-styles";
import { Menus } from "../../constants/menus-constant";
import { useLocation } from "react-router";
import ReactTable from 'react-table';

const Participants = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.loginUserReducer);
    const { loading, participantsData, pagination } = useSelector((state) => state.participantsReducer);

    const isProvider = (user?.institution?.id === providerInstitutionConstant?.id) && (user?.superAdmin);

    const MenuList = Menus({ user });

    const pageInfo = MenuList?.flatMap(i => i?.subMenus)?.filter(i => i?.to === location?.pathname)[0];

    const initialPagination = {
        currentPage: 0,
        pageSize: 20,
    };
    const initialOrderBy = {
        sortColumn: "createdDateTime",
        isAsce: true,
    };
    const initialSearch = {
        fullName: '',
        status: '',
        name: '',
        email: '',
        mobileNo: '',
        creationDate: '',
    };

    const initialForm = {
        participantName: '',
        // participantType: '',
        primaryPersonName: '',
        primaryPersonEmail: '',
        primaryPersonPhone: '',
        secondaryPersonName: '',
        secondaryPersonEmail: '',
        secondaryPersonPhone: '',
        logoSize: '',
        logoFormat: '',
        participantLogo: '',
        addParticipantBinRangeDto: [
            {
                schemeId: '',
                schemeName: '',
                bin: '',
                // ica: '',
                binStartRange: '',
                binEndRange: '',
                // currencies: []
            }
        ],
        cardValidator: '',
        authenticationTypeId: 1,
        otpValidityId: '',
        otpCharacteristicsId: '',
        otpDeliveries: [],
        customerCanSelectAuthMethod: false,
        isMultiLanguageSupport: false,
        smsVenderId: '',
        smsTemplate: '',
        senderEmail: '',
        emailSubject: '',
        emailTemplate: '',
    };

    const initialStates = {
        data: [],
        pagination: initialPagination,
        orderBy: initialOrderBy,
        search: initialSearch,
        selected: null,
        isDropdownOpen: false,
        isModalOpen: false,
        isConfirmModal: null,
        isUpdate: false,
        isView: false,
        isFiltersOpen: false,
    };

    const [states, setStates] = useState(initialStates);

    const [form, setForm] = useState(initialForm);

    const defaultParams = { pagination: states.pagination, orderBy: states.orderBy, search: states.search };

    const getAllParticipantsData = async (updatedParams) => {
        if (user && updatedParams) {
            try {
                await Promise.all([
                    dispatch(getAllParticipants({ user, ...updatedParams })),
                    dispatch(getParticipantsLogoDetail(user)),
                    dispatch(getParticipantsMessageInfo(user)),
                    dispatch(getCountryList(user)),
                ]);
            } catch (error) {
                console.error("One or more API calls failed", error);
            }
        }
    };


    // const handleReload = () => {
    //     getAllParticipantsData(defaultParams);
    //     // handleCloseFilters();
    // };

    const handlePagination = (e) => {
        const params = {
            ...defaultParams,
            pagination: {
                ...defaultParams.pagination,
                currentPage: e
            }
        };
        getAllParticipantsData(params);
        // handleCloseFilters();
    };

    const handleChangeFilters = (e) => {
        const { name, value, type, checked } = e.target
        setStates((old) => ({
            ...old,
            search: ({
                ...old.search,
                [name]: ['checkbox', 'radio'].includes(type) ? checked : value
            })
        }));
    };

    const handleSelectRow = (row) => {
        if (row === states.selected && states.isDropdownOpen) {
            setStates((old) => ({ ...old, isDropdownOpen: false, selected: null }));
        } else {
            setStates((old) => ({ ...old, isDropdownOpen: true, selected: row }));
        }
    };

    const handleCloseDropdown = () => {
        setStates((old) => ({ ...old, isDropdownOpen: false }));
    };

    const handleToggleFilters = () => {
        setStates((old) => ({ ...old, search: initialSearch, isFiltersOpen: !states.isFiltersOpen }));
    };

    // const handleCloseFilters = () => {
    //     setStates((old) => ({ ...old, search: initialSearch, isFiltersOpen: false }));
    // };

    const handleModalOpen = (e) => {
        if (['view', 'edit', 'activate', 'deactivate'].includes(e)) {
            const { institution, institutionDetails, participantBinRanges } = states.selected;
            setForm({
                id: institution?.id || '',
                participantName: institutionDetails?.participantName || '',
                // participantType: institutionDetails?.participantType || '',
                primaryPersonName: institutionDetails?.primaryPersonName || '',
                primaryPersonEmail: institutionDetails?.primaryPersonEmail || '',
                primaryPersonPhone: institutionDetails?.primaryPersonPhone || '',
                secondaryPersonName: institutionDetails?.secondaryPersonName || '',
                secondaryPersonEmail: institutionDetails?.secondaryPersonEmail || '',
                secondaryPersonPhone: institutionDetails?.secondaryPersonPhone || '',
                logoSize: institutionDetails?.logoSize || '',
                logoFormat: institutionDetails?.logoFormat || '',
                participantLogo: institutionDetails?.participantLogo || '',
                addParticipantBinRangeDto: participantBinRanges ? participantBinRanges.map((bin) => ({
                    id: bin?.id || null,
                    schemeId: bin?.schemeId?.id || '',
                    schemeName: bin?.schemeId?.id || '',
                    bin: bin?.bin || '',
                    // ica: bin?.ica || '',
                    binStartRange: bin?.binStartRange || '',
                    binEndRange: bin?.binEndRange || '',
                    // currencies: bin?.currencies ? bin.currencies.map((c) => c?.currencyCode ?? '') : [],
                })) : [],
                cardValidator: institutionDetails?.cardValidator?.id || '',
                authenticationTypeId: institutionDetails?.authenticationTypeId?.id || 1,
                otpValidityId: institutionDetails?.otpValidityId?.id || '',
                otpCharacteristicsId: institutionDetails?.otpCharacteristicstId?.id || '',
                otpDeliveries: institutionDetails?.otpDeliveries ? institutionDetails?.otpDeliveries?.filter(e => e.isActive).map(({ id }) => id) : [],
                customerCanSelectAuthMethod: institutionDetails?.customerCanSelectAuthMethod,
                isMultiLanguageSupport: institutionDetails?.isMultiLanguageSupport,
                smsVenderId: institutionDetails?.smsVendorId?.id || '',
                smsTemplate: institutionDetails?.smsTemplate || '',
                senderEmail: institutionDetails?.senderEmail || '',
                emailSubject: institutionDetails?.emailSubject || '',
                emailTemplate: institutionDetails?.emailTemplate || '',
            });
            if (e === 'view') {
                setStates((old) => ({ ...old, isView: true, isModalOpen: true }));
            } else if (e === 'edit') {
                setStates((old) => ({ ...old, isUpdate: true, isModalOpen: true }));
            } else if (['activate', 'deactivate'].includes(e)) {
                setStates((old) => ({ ...old, isUpdate: true, isConfirmModal: e }));
            }
        } else {
            setStates((old) => ({ ...old, isModalOpen: true }));
            setForm(initialForm);
        }
    };

    const handleModalClose = () => {
        setStates((old) => ({ ...old, isModalOpen: false, isConfirmModal: null, selected: null, isUpdate: false, isView: false }));
    };

    const handleFormSubmit = (payload) => {
        if (user && payload) {
            dispatch(postAddUpdateParticipant({ user, body: payload, update: states.isUpdate })).then((action) => {
                if (action?.payload?.status === 201 || action?.payload?.status === 200) {
                    handleModalClose();
                    getAllParticipantsData(defaultParams);
                }
            });
        }
    };

    const handleActivate = (state) => {
        if (user && form) {
            const updatedBody = {
                ...form,
                isActive: state,
                changeStatus: true,
            };

            dispatch(postAddUpdateParticipant({ user, body: updatedBody, update: states.isUpdate })).then((action) => {
                if (action?.payload?.status === 201 || action?.payload?.status === 200) {
                    handleModalClose();
                    getAllParticipantsData(defaultParams);
                }
            });
        }
    };

    const handleFiltersSubmit = (e, customSearch = null) => {
        if (e) e.preventDefault();
        const searchToUse = customSearch || states.search;
        const params = {
            ...defaultParams,
            search: searchToUse,
            pagination: initialPagination,
        };
        getAllParticipantsData(params);
    };

    const handleTableFilterChange = (key, value, submit = false) => {
        setStates(old => {
            const updatedSearch = { ...old.search, [key]: value || '' };
            if (submit) {
                setTimeout(() => {
                    handleFiltersSubmit(null, updatedSearch);
                }, 0);
            }
            return { ...old, search: updatedSearch };
        });
    };

    // const handleFiltersSubmit = (e) => {
    //     e.preventDefault();

    //     const filterConditions = {
    //         fullName: (item, value) =>
    //             item.institution.descr.toLowerCase().includes(value.toLowerCase()),
    //         name: (item, value) =>
    //             item.institutionDetails.primaryPersonName.toLowerCase().includes(value.toLowerCase()),
    //         email: (item, value) =>
    //             item.institutionDetails.primaryPersonEmail.toLowerCase().includes(value.toLowerCase()),
    //         mobileNo: (item, value) =>
    //             item.institutionDetails.primaryPersonPhone.includes(value),
    //         status: (item, value) =>
    //             item.institution.institutionStatus.code.includes(value.toLowerCase()),
    //         date: (item, value) => {
    //             const filterDate = new Date(value);
    //             const day = String(filterDate.getDate()).padStart(2, '0');
    //             const month = String(filterDate.getMonth() + 1).padStart(2, '0');
    //             const year = filterDate.getFullYear();

    //             const formattedFilterDate = `${day}-${month}-${year}`;

    //             return item.institution.createdDateTime.includes(formattedFilterDate);
    //         }
    //     };

    //     let updatedItems = states?.data;

    //     for (const [key, condition] of Object.entries(filterConditions)) {
    //         if (states.search[key]) {
    //             updatedItems = updatedItems.filter((item) => condition(item, states.search[key]));
    //         }
    //     }

    //     setStates((old) => ({ ...old, filteredData: updatedItems }));
    // };

    const actions = (status) => {
        const actionsList = [
            { label: 'View', action: () => handleModalOpen('view') },
        ];

        if (status === statusConstant?.activeValue) {
            actionsList.push({ label: 'Edit', action: () => handleModalOpen('edit') });

            if (isProvider) {
                actionsList.push({ label: 'Deactivate', action: () => handleModalOpen('deactivate') });
            }
        }
        else if (status === statusConstant?.inactiveValue) {
            actionsList.push({ label: 'Activate', action: () => handleModalOpen('activate') });
        }

        return actionsList;
    };


    useEffect(() => {
        getAllParticipantsData(defaultParams);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (participantsData && Array.isArray(participantsData)) {
            setStates((old) => ({ ...old, data: participantsData, pagination: pagination }));
        }
    }, [participantsData]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.action-dropdown')) {
                handleCloseDropdown();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const searchFields = [
        {
            label: 'Full Name',
            type: 'text',
            placeholder: 'Search by full name',
            name: 'fullName',
            value: states.search.fullName,
        },
        // {
        //     label: 'Contact Person Name',
        //     type: 'text',
        //     placeholder: 'Search by name',
        //     name: 'name',
        //     value: states.search.name,
        // },
        // {
        //     label: 'Contact Person Email',
        //     type: 'email',
        //     placeholder: 'Search by email',
        //     name: 'email',
        //     value: states.search.email,
        // },
        // {
        //     label: 'Contact Person Phone',
        //     type: 'text',
        //     placeholder: 'Search by mobile number',
        //     name: 'mobileNo',
        //     value: states.search.mobileNo,
        // },
        {
            label: 'Status',
            type: 'select',
            options: statusOptions,
            name: 'status',
            value: states.search.status,
        },
        {
            label: 'Created At',
            type: 'date',
            placeholder: 'Search by date',
            name: 'creationDate',
            value: states.search.creationDate,
        },
        {
            type: 'action',
            actions: [
                { label: 'Cancel', icon: CrossSvg, type: 'button', outline: true, action: handleToggleFilters },
                { label: 'Search', icon: SearchSvg, type: 'submit', action: () => { } }
            ],
        }
    ];
    // const columns = [
    //     {
    //         field: 'descr', headerName: 'Full Name', width: 140,
    //         valueGetter: (row) => row?.institution?.descr
    //     },
    //     {
    //         field: 'institutionStatus',
    //         headerName: 'Status',
    //         width: 90,
    //         align: 'center',
    //         valueGetter: (row) => {
    //             return (
    //                 <>
    //                     {
    //                         row?.institution?.institutionStatus &&
    //                         <BadgeComponent
    //                             label={row?.institution?.institutionStatus?.descr}
    //                             type={{
    //                                 [statusConstant?.activeValue]: 'success',
    //                                 [statusConstant?.inactiveValue]: 'warning',
    //                                 [statusConstant?.lockedValue]: 'error'
    //                             }[row?.institution?.institutionStatus?.code] || 'default'}
    //                         />
    //                     }
    //                 </>
    //             )
    //         },
    //         sortBy: (row) => row?.institution?.institutionStatus?.descr,
    //     },
    //     {
    //         field: 'primaryPersonName', headerName: 'Contact Person Name', width: 160,
    //         valueGetter: (row) => row?.institutionDetails?.primaryPersonName
    //     },
    //     {
    //         field: 'primaryPersonEmail', headerName: 'Contact Person Email', width: 160,
    //         valueGetter: (row) => row?.institutionDetails?.primaryPersonEmail
    //     },
    //     {
    //         field: 'primaryPersonPhone', headerName: 'Contact Person Phone', type: 'number', width: 170, align: 'center',
    //         valueGetter: (row) => row?.institutionDetails?.primaryPersonPhone
    //     },
    //     {
    //         field: 'createdDateTime', headerName: 'Created At', width: 170, align: 'center',
    //         valueGetter: (row) => row?.institution?.createdDateTime
    //     },
    //     {
    //         field: 'action',
    //         headerName: 'Action',
    //         sortable: false,
    //         width: 100,
    //         align: 'right',
    //         sticky: 'right',
    //         valueGetter: (row) => {
    //             return (
    //                 <div className="action-dropdown" style={{ position: 'relative', float: 'right' }}>
    //                     <IconButtonComponent outline={!(states.isDropdownOpen && states.selected === row)} size='small' icon={VerticalDotsSvg} onClick={() => handleSelectRow(row)} />
    //                     <DropDownComponent isOpen={states.isDropdownOpen && states.selected === row} close={handleCloseDropdown} actions={actions(row?.institution?.institutionStatus?.code)} />
    //                 </div>
    //             )
    //         },
    //     },
    // ];


    // TABLE COLUMNS SETUP AS PER DATA
    const columns = useMemo(() => [
        {
            accessor: 'createdDateTime',
            Header: 'Created At',
            minWidth: 150,
            style: {
                textAlign: 'center',
            },
            Cell: (row) => row?.original?.institution?.createdDateTime || '-',
            sortable: false,
            Filter: ({ filter, onChange }) => (
                <input
                    type="date"
                    name="creationDate"
                    value={filter ? filter.value : ''}
                    onChange={(e) => {
                        const value = e.target.value;
                        onChange(value);
                        handleTableFilterChange('creationDate', value, true);
                    }}
                    // onKeyDown={(e) => {
                    //     if (e.key === 'Enter' || e.keyCode === 13 || e.which === 13) {
                    //         const value = e.target.value === '' ? undefined : e.target.value;
                    //         onChange(value);
                    //         handleTableFilterChange('creationDate', value, true);
                    //     }
                    // }}
                    placeholder="Search by date"
                    style={{ width: '100%' }}
                />
            ),
            filterable: isProvider ? true : false,
        },
        {
            accessor: 'descr',
            Header: 'Full Name',
            minWidth: 150,
            style: {
                textAlign: 'center'
            },
            Cell: (row) => row?.original?.institution?.descr || '-',
            sortable: false, Filter: ({ filter, onChange }) => (
                <input
                    type="text"
                    name="fullName"
                    value={filter ? filter.value : ''}
                    onChange={(e) => {
                        const value = e.target.value;
                        onChange(value);
                        handleTableFilterChange('fullName', value);
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.keyCode === 13 || e.which === 13) {
                            const value = e.target.value === '' ? undefined : e.target.value;
                            onChange(value);
                            handleTableFilterChange('fullName', value, true);
                        }
                    }}
                    placeholder="Search by full name"
                    style={{ width: '100%' }}
                />
            ),
            filterable: isProvider ? true : false,
        },
        {
            accessor: 'participantLogo',
            Header: 'Logo',
            minWidth: 120,
            style: {
                textAlign: 'center',
            },
            Cell: (row) => {
                const logo = row?.original?.institutionDetails?.participantLogo;
                if (logo) {
                    return <img src={logo} alt="Logo" style={{ width: '100%', maxWidth: 50, height: 'auto' }} />;
                }
                return null;
            },
            sortable: false,
            filterable: false,
        },
        {
            accessor: 'institutionStatus',
            Header: 'Status',
            minWidth: 120,
            style: {
                textAlign: 'center',
            },
            Cell: (row) => {
                return (
                    <>
                        {
                            row?.original?.institution?.institutionStatus &&
                            <BadgeComponent
                                label={row?.original?.institution?.institutionStatus?.descr}
                                type={{
                                    [statusConstant?.activeValue]: 'success',
                                    [statusConstant?.inactiveValue]: 'warning',
                                    [statusConstant?.lockedValue]: 'error'
                                }[row?.original?.institution?.institutionStatus?.code] || 'default'}
                            />
                        }
                    </>
                )
            },
            sortable: false,
            Filter: ({ filter, onChange }) => (
                <select
                    name="status"
                    value={filter ? filter.value : ''}
                    onChange={(e) => {
                        const value = e.target.value;
                        onChange(value);
                        handleTableFilterChange('status', value, true);
                    }}
                    style={{ width: '100%' }}
                >
                    <option value="">All</option>
                    {
                        statusOptions.map((item, index) => (
                            <option key={index} value={item.value}>
                                {item.label}
                            </option>
                        ))
                    }
                </select>
            ),
            filterable: isProvider ? true : false,
        },
        // {
        //     accessor: 'primaryPersonName',
        //     Header: 'Contact Person Name',
        //     minWidth: 160,
        //     Cell: (row) => row?.original?.institutionDetails?.primaryPersonName || '-',
        //     sortable: false,
        //     filterable: false,
        // },
        // {
        //     accessor: 'primaryPersonEmail',
        //     Header: 'Contact Person Email',
        //     minWidth: 160,
        //     Cell: (row) => row?.original?.institutionDetails?.primaryPersonEmail || '-',
        //     sortable: false,
        //     filterable: false,
        // },
        // {
        //     accessor: 'primaryPersonPhone',
        //     Header: 'Contact Person Phone',
        //     minWidth: 170,
        //     style: {
        //         textAlign: 'center',
        //     },
        //     Cell: (row) => row?.original?.institutionDetails?.primaryPersonPhone || '-',
        //     sortable: false,
        //     filterable: false,
        // },

        {
            accessor: 'action',
            Header: 'Action',
            minWidth: 100,
            // style: {
            //     height: 45, display: 'flex', justifyContent: 'flex-end', alignItems: 'center'
            // },
            Cell: (row) => {
                return (
                    <div className="action-dropdown" style={{ position: 'absolute' }}>
                        <IconButtonComponent outline={!(states.isDropdownOpen && states.selected === row?.original)} size='small' icon={VerticalDotsSvg} onClick={() => handleSelectRow(row?.original)} />
                        <DropDownComponent isOpen={states.isDropdownOpen && states.selected === row?.original} close={handleCloseDropdown} actions={actions(row?.original?.institution?.institutionStatus?.code)} />
                    </div>
                )
            },
            sortable: false,
            filterable: false,
        },
    ], [states.isDropdownOpen, states.selected]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <AuthPageContainer $heightfull>
            {/* BACK BUTTON */}
            <BackButton />
            {/* PAGE HEAD */}
            <AuthPageHead>
                <div className="left">
                    <pageInfo.icon className="page-icon" />
                    <h1>Participants</h1>
                    {/* <IconButtonComponent icon={ReloadSvg} outline size="small" disabled={loading} onClick={handleReload} className={loading && 'box-spin'} /> */}
                    <Breadcrumbs
                        items={[
                            { label: "Home", to: "/app/home" },
                            { label: pageInfo.label }
                        ]}
                        separator="›"
                        activeLastBreadcrumb={false}
                        size="small"
                        color={'var(--text-color-secondary)'}
                    />
                </div>

                <div className="right">
                    {
                        isProvider ? (
                            <ButtonComponent icon={PlusSvg} label="Add Participant" size="small" disabled={loading} onClick={handleModalOpen} />
                        ) : null
                    }
                    {/* <IconButtonComponent icon={FilterSvg} outline onClick={handleToggleFilters} /> */}
                </div>
            </AuthPageHead>

            {/* FILTER */}
            {
                searchFields && searchFields.length > 0 &&
                <FiltersComponent open={states.isFiltersOpen} searchFields={searchFields} handleChange={handleChangeFilters} handleSubmit={handleFiltersSubmit} />
            }

            {/* LOADING STATE */}
            {
                loading &&
                <LoaderComponent />
            }

            {/* EMPTY STATE */}
            {/* {
                !loading && states.data && states.data.length === 0 &&
                <EmptyTableComponent text='No data found!' />
            } */}

            {/* PAGE CONTENT */}
            {
              <>
                   <PaginationComponent
                        page={states?.pagination?.currentPage}
                        pages={states?.pagination?.totalPages || 1}
                        onPageChange={(e) => handlePagination(e)}
                        canPrevious={states?.pagination?.currentPage > 0}
                        canNext={states?.pagination?.currentPage < (states?.pagination?.totalPages - 1)}
                    />
                    <ReactTableWrapper className="box-shadow custom-scrollbar">
                        {/* <TableComponent rows={states.data} columns={columns} icon={BadgeSvg} />
                    <PaginationComponent data={states.pagination} handleChange={(e) => handlePagination(e)} /> */}
                        <ReactTableWrappers>
                            <ReactTable
                                manual
                                loading={loading}
                                data={states?.data}
                                columns={columns}
                                page={states?.pagination?.currentPage || 0}
                                pageSize={states?.pagination?.pageSize || 20}
                                pages={states?.pagination?.totalPages || 1}
                                filterable={true}
                                showPagination={false}
                                showPageJump={true}
                                showPageSizeOptions={false}
                                showPaginationTop={true}
                                showPaginationBottom={false}
                                onPageChange={(e) => handlePagination(e)}
                                minRows={0}
                            // defaultFilterMethod={(filter, row, column) => {
                            //     return true;
                            // }}
                            // onFilteredChange={(filtered, column, value) => {
                            //     const searchCriteria = transformToObject(filtered);
                            //     setComponentState((prevState) => ({
                            //         ...prevState,
                            //         searchCriteria,
                            //         tableLoading: true,
                            //     }));

                            //     handleOnSearch(searchCriteria); // Trigger handle search
                            // }}
                            />
                        </ReactTableWrappers>
                    </ReactTableWrapper>
                </>
            }

            {/* MODALS */}
            {
                states.isModalOpen &&
                <AddUpdateParticipantModal user={user} data={form} label={`${states.isView ? 'View' : states.isUpdate ? 'Update' : 'Add'} Participant`} update={states.isUpdate} viewOnly={states.isView} close={handleModalClose} handleFormSubmit={handleFormSubmit} emptyBinRange={initialForm?.addParticipantBinRangeDto?.[0]} slide />
            }
            {
                states.isConfirmModal && states.isConfirmModal === 'activate' &&
                <ConfirmationModalComponent
                    type='success'
                    label='Activate participant'
                    text={`Are you sure you want to activate participant (${states?.selected?.institutionDetails?.participantName})?`}
                    close={handleModalClose}
                    actions={[
                        { label: 'No', type: 'button', outline: true, action: handleModalClose },
                        { label: 'Yes', type: 'button', action: () => handleActivate(true) }
                    ]}
                />
            }
            {
                states.isConfirmModal && states.isConfirmModal === 'deactivate' &&
                <ConfirmationModalComponent
                    type='warning'
                    label='Deactivate participant'
                    text={`Are you sure you want to deactivate participant (${states?.selected?.institutionDetails?.participantName})?`}
                    close={handleModalClose}
                    actions={[
                        { label: 'No', type: 'button', outline: true, action: handleModalClose },
                        { label: 'Yes', type: 'button', action: () => handleActivate(false) }
                    ]}
                />
            }
        </AuthPageContainer>
    );
};

export default Participants;